import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import {
  BIG_MARGIN,
  colorsPalette,
  LARGE_MARGIN,
  MIDDLE_MARGIN,
  SMALL_MARGIN,
  SUBMIDDLE_MARGIN,
  TINY_MARGIN,
} from '../../theme';

const useStyles = (hasSubscription, withChild = false) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        minHeight: 650,
        [theme.breakpoints.up('md')]: {
          minHeight: 'calc(100vh - 40px)',
        },
      },
      errorWrapper: {
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      imgWrapper: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: 650,
        [theme.breakpoints.up('md')]: {
          height: 'calc(100vh - 40px)',
        },
        '&::before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          width: '100%',
          left: 0,
          top: 0,
          height: '100%',
          background: hasSubscription
            ? 'linear-gradient(90deg, #1B1925 0%, #1B1925AA 50%, #1B192500 100%) 0% 0% no-repeat'
            : 'linear-gradient(90deg, #1B1925 0%, #1B1925AA 60%, #1B192500 100%) 0% 0% no-repeat',
          zIndex: 2,
          [theme.breakpoints.down('md')]: {
            background: 'rgba(27, 25, 37, 0.698039)',
          },
        },
        '&::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '373px',
          background: 'linear-gradient(0deg, #1B1925 0%, rgba(27, 25, 37, 0.0001) 100%)',
          zIndex: 2,
        },
      },
      topGradient: {
        width: '100%',
        height: '107px',
        position: 'absolute',
        left: 0,
        top: 0,
        background: 'linear-gradient(180deg, #1B1925 0%, rgba(45, 50, 56, 0.0001) 100%)',
        '-webkit-background-origin': 'padding-box',
        '-o-background-origin': 'padding-box',
        '-moz-background-origin': 'padding-box',
        zIndex: 2,
      },
      leftGradient: {
        width: '70%',
        height: '100%',
        position: 'absolute',
        left: 0,
        top: 0,
        background:
          'linear-gradient(90deg, #1B1925 0%, #1B1925AA 60%, #1B192500 100%) 0% 0% no-repeat',
        '-webkit-background-origin': 'padding-box',
        '-o-background-origin': 'padding-box',
        '-moz-background-origin': 'padding-box',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      img: {
        height: '100%',
        width: '100%',
        objectFit: 'cover',
      },
      contentWrapper: {
        position: 'relative',
        zIndex: 3,
        paddingTop: 1,
      },
      headerWrapper: {
        position: 'relative',
        marginTop: hasSubscription ? (withChild ? 90 : 135) : 105,
        marginBottom: BIG_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginTop: hasSubscription ? '160px' : '27vh',
          marginBottom: 160,
        },
      },
      headerContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        maxWidth: 980,
      },
      avatar: {
        borderRadius: '50%',
        border: `2px solid ${colorsPalette.white}`,
        width: hasSubscription ? 60 : 40,
        height: hasSubscription ? 60 : 40,
        marginBottom: 0,
        marginRight: 25,
        [theme.breakpoints.up('md')]: {
          marginBottom: 0,
        },
      },
      title: {
        lineHeight: 1.2,
        marginBottom: hasSubscription ? SMALL_MARGIN : 24,
        textAlign: hasSubscription ? 'left' : 'center',
        [theme.breakpoints.up('md')]: {
          fontSize: hasSubscription ? 32 : 48,
          textAlign: 'left',
        },
      },
      author: {
        lineHeight: 1,
        marginBottom: 0,
        fontSize: 18,
        [theme.breakpoints.up('md')]: {
          marginBottom: 0,
        },
      },
      description: {
        textAlign: hasSubscription ? 'left' : 'center',
        color: colorsPalette.gray,
        fontStyle: 'normal',
        fontSize: 18,
        lineHeight: 1.5,
        marginBottom: MIDDLE_MARGIN,
        maxWidth: '100%',
        [theme.breakpoints.up('md')]: {
          fontSize: 22,
          textAlign: 'left',
        },
      },
      authorBlock: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 25,
        '& > a': {
          color: colorsPalette.white,
        },
      },
      textWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: hasSubscription ? 'flex-start' : 'center',
        position: 'relative',
        [theme.breakpoints.up('md')]: {
          alignItems: 'flex-start',
          width: 493,
          maxWidth: 'calc(50% - 100px)',
        },
      },
      categoriesWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        width: '100%',
        marginBottom: '-10px',
        '& > a, & > div': {
          marginRight: 9,
          marginBottom: 9,
        },
        [theme.breakpoints.up('md')]: {
          width: '50%',
          justifyContent: 'flex-start',
          minWidth: 'calc(50% - 100px)',
        },

        '& div': {
          marginRight: 10,
          '&:last-child': {
            marginRight: 0,
          },
        },
      },
      playBtn: {
        cursor: 'pointer',
        marginBottom: '25px',
        marginTop: '25px',
        width: 45,
        height: 45,
        background: 'rgba(29, 29, 41, 0.501961);',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
      },
      playBtnIcon: {
        cursor: 'pointer',
        marginLeft: '5px',
        width: '19px',
        height: '22px',
      },
      playBtnDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
          cursor: 'pointer',
          position: 'absolute',
          left: '50%',
          top: 170,
          transform: 'translate(-50%, -50%)',
          width: 125,
          height: 125,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'rgba(29, 29, 41, 0.501961);',
          borderRadius: '50%',
          zIndex: 4,
        },
      },
      playBtnDesktopIcon: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
          cursor: 'pointer',
          display: 'block',
          width: '52px',
          height: '60px',
          fontSize: '80px',
          zIndex: 4,
          marginLeft: 13,
        },
      },
      mobileNav: {
        [theme.breakpoints.up('md')]: {
          display: 'none',
        },
      },
      desktopNav: {
        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
      },
      modal: {
        display: 'flex',
        justifyContent: 'center',
        alightItems: 'center',
      },
      videoContainer: {
        marginTop: 50,
        maxWidth: 1568,
        width: '100%',
        marginBottom: 40,
        [theme.breakpoints.up('md')]: {
          marginBottom: 55,
          marginTop: 110,
        },
        [theme.breakpoints.up('lg')]: {
          width: '80vw',
        },
      },
      blockWrap: {
        flex: 1,
      },
      videoWrap: {
        position: 'relative',
        zIndex: 10,
      },
      playerContainer: {
        height: '50vh',
        width: '100%',
        overflow: 'hidden',
        borderRadius: '10px',
        [theme.breakpoints.up('md')]: {
          height: '60vh',
        },
        [theme.breakpoints.up('xl')]: {
          height: 460,
        },
      },
      topBordered: {
        borderRadius: '10px 10px 0 0',
      },
      playerWrapper: {
        height: '100%',
        width: '100%',
      },
      video: {
        width: '100%',
        height: '100%',
      },
      videoBlock: {
        position: 'relative',
        zIndex: 10,
        marginBottom: MIDDLE_MARGIN,
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('lg')]: {
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: LARGE_MARGIN,
        },
      },
      videoCardsContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
        [theme.breakpoints.up('lg')]: {
          marginLeft: MIDDLE_MARGIN,
          marginTop: 0,
          display: 'block',
          margin: '15px auto 0 auto',
        },
      },
      videosBlock: {
        width: '100%',
        height: hasSubscription ? 'initial' : '100%',
        maxWidth: 343,
        marginBottom: MIDDLE_MARGIN,
        '&:last-child': {
          marginBottom: 0,
        },
      },
      videosBlockTitle: {
        fontSize: 20,
        lineHeight: 1,
        marginBottom: 28,
      },
      removeIcon: {
        width: 20,
        height: 20,
        paddingTop: 4,
      },
      joinNowContainer: {
        marginTop: 24,
        marginBottom: 32,
        [theme.breakpoints.up('md')]: {
          marginBottom: 88,
          marginTop: 85,
        },
      },
      hidden: {
        display: 'none',
      },
      pathwayNameRow: {
        display: 'flex',
        alignItems: 'center',
        marginTop: SMALL_MARGIN,
      },
      pathwayIcon: {
        width: 18,
        height: 18,
        marginRight: TINY_MARGIN,
        color: colorsPalette.blue,
      },
      pathwayName: {
        marginLeft: 5,
        marginRight: 5,
        fontWeight: 700,
        color: colorsPalette.white,
      },
    }),
  );

export const useJoinNowStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: 'sticky',
      top: 100,
      padding: 0,
    },
    container: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      position: 'relative',
      padding: `${MIDDLE_MARGIN}px ${MIDDLE_MARGIN}px ${MIDDLE_MARGIN}px ${
        BIG_MARGIN + TINY_MARGIN
      }px`,
      background: colorsPalette.blackSecondary,
      maxWidth: 343,
      margin: 0,
      [theme.breakpoints.up('md')]: {
        maxWidth: 318,
      },
    },
    lockIcon: {
      position: 'absolute',
      left: SUBMIDDLE_MARGIN,
      width: 24,
      height: 24,
      marginTop: 10,
      [theme.breakpoints.up('md')]: {
        marginTop: 0,
      },
    },
    lockText: {
      fontSize: 18,
      margin: `0px 0px ${TINY_MARGIN}px`,
      width: '100%',
    },
    description: {
      fontSize: 16,
      marginBottom: SUBMIDDLE_MARGIN,
      width: '100%',
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
    link: {
      width: '100%',
    },
  }),
);

export default useStyles;
